import type { NuxtApp } from '#app';
import type { AttributeType } from '~/types/plugins/subscriptions';
import application from '../../config/application.json';

const cycle = (cycleTime: string) => {
  switch (cycleTime) {
    case 'P1D':
      return 'Daily';
    case 'P7D':
      return 'Weekly';
    case 'P1M':
      return 'Monthly';
    case 'P1Y':
      return 'Yearly';
    default:
      return cycleTime;
  }
};

enum Currency {
  EUR = '€',
  USD = '$',
}

enum ConsentType {
  MARKETING = 'MARKETING',
  NOTIFICATION = 'NOTIFICATION',
  TERMS_CONDITIONS = 'TERM_CONDITIONS',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
}

const currency = (priceCurrency: keyof typeof Currency): string => {
  return Currency[priceCurrency] || priceCurrency;
};

const price = (
  itemPrice: {
    amount: number;
    currency: string;
    vatRate: number;
  },
  attributes: AttributeType[],
  self: NuxtApp,
) => {
  let count = self.$globals?.priceFormat?.count;
  const num = itemPrice?.amount?.toFixed(
    Number(count) ? Number(count) : Number(count) === 0 ? 0 : 2,
  );
  if (
    attributes?.find(
      (attr) =>
        attr.key ===
        (('DISPLAY_SERVICE_CURRENCY_TEXT_' +
          (self.$i18n.locale.value || self.$i18n.locale)) as String),
    )
  ) {
    itemPrice.currency =
      attributes?.find(
        (attr) =>
          attr.key ===
          (('DISPLAY_SERVICE_CURRENCY_TEXT_' +
            (self.$i18n.locale.value || self.$i18n.locale)) as String),
      )?.value || '';
  }
  return self.$filters.formatNumbers(num) + itemPrice?.currency;
};
const getGenres = (itemGenres: any[]) => {
  let genres: { name: string; localizedName: string }[] = [];
  itemGenres?.forEach((genre) => {
    let name = (genre.name || genre)?.toLowerCase();
    name = name.charAt(0).toUpperCase() + name.slice(1);
    genres.push({ name: name, localizedName: genre.localizedName || name });
  });
  return genres?.splice(0, 2);
};

const formatBinarySize = (bytes: number): string => {
  return `${Math.ceil(bytes / 1024 / 1024)}MB`;
};

const priceCycle = (cycleTime: string) => {
  switch (cycleTime) {
    case 'P1D':
      return 'Day';
    case 'P7D':
      return 'Week';
    case 'P1M':
      return 'Month';
    case 'P1Y':
      return 'Year';
    default:
      return cycleTime;
  }
};

const calculatefreeTrial = (item: any) => {
  if (item?.subscriptionTypeList?.[0]?.maxTrialDuration) {
    let period = [...item.subscriptionTypeList[0]?.maxTrialDuration][1];
    let duration = [...item.subscriptionTypeList[0]?.maxTrialDuration][2];
    const { $t } = useNuxtApp();

    switch (duration) {
      case 'D':
        return `${period} ` + $t('days.free');
      case 'M':
        return `${period} ` + $t('months.free');
      case 'Y':
        return `${period} ` + $t('years.free');
      default:
        return item?.subscriptionTypeList?.[0]?.maxTrialDuration;
    }
  }
};
const calculateDiscount = (item: any) => {
  const { $t } = useNuxtApp();

  if (
    item?.subscriptionTypeList?.[0]?.subscriptionTypePromotionPrice?.amount &&
    item?.subscriptionTypeList?.[0]?.subscriptionTypePrice.amount &&
    item?.subscriptionTypeList?.[0]?.subscriptionTypePromotionPrice?.amount <
      item?.subscriptionTypeList?.[0]?.subscriptionTypePrice.amount
  ) {
    return (
      `${
        (item.subscriptionTypeList[0].subscriptionTypePromotionPrice.amount /
          item.subscriptionTypeList[0].subscriptionTypePrice.amount) *
        100
      }% ` + $t('tag.off')
    );
  }
};

const calculateNew = (item: any) => {
  if (item?.subscriptionTypeList?.[0]?.attributes) {
    item?.subscriptionTypeList?.[0]?.attributes?.map((i) => {
      if (i.key == 'monsooq_new' && i.value == true) {
        return 'tag.new';
      }
    });
  }
};

const contentGrading = (grading: number) => {
  switch (grading) {
    case 0:
      return 'grading.allAges';
    case 10:
      return 'grading.6plus';
    case 20:
      return 'grading.12plus';
    case 30:
      return 'grading.16plus';
    case 40:
      return 'grading.18plus';
    default:
      return 'grading.18plus';
  }
};
const array_chunks = (array: any[], chunk_size: number) => {
  var matrix = [],
    i,
    k;
  try {
    for (i = 0, k = -1; i < array?.length; i++) {
      if (i % chunk_size === 0) {
        k++;
        matrix[k] = [];
      }

      matrix[k].push(array[i]);
    }
  } catch (error) {
    throw error;
  }
  return matrix;
};

const goBack = (self: NuxtApp) => {
  //window.history.length === 1 if we used nuxt fetch data
  //window.history.length === 2 if we used nuxt async data
  if (window.history.length <= 2) {
    self.$router.push('/');
  } else {
    self.$router.go(-1);
  }
};
const detailPrice = (
  itemPrice: {
    amount: number;
    currency: string;
    vatRate: number;
  },
  attributes: AttributeType[],
  self: NuxtApp,
) => {
  if (
    attributes &&
    attributes.find(
      (attr) =>
        attr.key ===
        (('DISPLAY_SERVICE_CURRENCY_TEXT_' +
          (self.$i18n.locale.value || self.$i18n.locale)) as String),
    )
  ) {
    if (!itemPrice) {
      return;
    }
    itemPrice.currency =
      attributes?.find(
        (attr) =>
          attr.key ===
          'DISPLAY_SERVICE_CURRENCY_TEXT_' +
            (self.$i18n.locale.value || self.$i18n.locale),
      )?.value || '';
  }
  let currencyTxt = itemPrice?.currency;
  if (
    self.$globals?.priceFormat &&
    self.$globals?.priceFormat[
      'currency_' + (self.$i18n.locale.value || self.$i18n.locale)
    ]
  ) {
    currencyTxt =
      self.$globals?.priceFormat[
        'currency_' + (self.$i18n.locale.value || self.$i18n.locale)
      ];
  }
  let count = self.$globals?.priceFormat?.count;
  const amount = itemPrice?.amount
    ?.toFixed(Number(count) ? Number(count) : Number(count) === 0 ? 0 : 2)
    .split('.');
  const priceDetail = {
    currency: currencyTxt,
    amountMain: self.$filters.formatNumbers(amount && amount[0]),
    amountExt: self.$filters.formatNumbers(amount && amount[1]),
  };
  return priceDetail;
};
const priceTag = (item: any, self: NuxtApp) => {
  if (item?.prices) {
    let currency = self.$t(`currency.${item.prices[0]?.currency}`);
    if (
      self.$globals?.priceFormat &&
      self.$globals?.priceFormat[
        ('currency_' + (self.$i18n.locale.value || self.$i18n.locale)) as string
      ]
    ) {
      currency =
        self.$globals?.priceFormat[
          ('currency_' +
            (self.$i18n.locale.value || self.$i18n.locale)) as string
        ];
    }
    let amount = item.prices[0]?.amount;
    let count = self.$globals?.priceFormat?.count;
    amount = amount
      .toFixed(Number(count) ? Number(count) : Number(count) === 0 ? 0 : 2)
      .split('.');
    const priceDetail = {
      currency: currency,
      amountMain: self.$filters.formatNumbers(amount[0]),
      amountExt:
        amount[1] === '00'
          ? self.$filters.formatNumbers(0)
          : self.$filters.formatNumbers(amount[1]),
    };
    return priceDetail;
  }
};
const closeMenuDuplication = (self: NuxtApp) => {
  // to close settings menu when another menu opens
  self.$emitter.emit('closeMenu');
  // self.$root.$emit('closeMenu');
  // to not display another menu
  let activeMenus = document.querySelectorAll('.menuable__content__active');
  if (activeMenus.length > 0) {
    activeMenus.forEach((element) => {
      if (element instanceof HTMLElement) {
        element.style.display = 'none';
      }
    });
  }
};
const replaceUrlParams = (
  url: string,
  query: { [key: string]: string },
  auth: any,
) => {
  let loops = 0;

  while (true) {
    const regex = '\\${([^}]*)}';
    if (!url || typeof url != 'string') {
      break;
    }
    let result = url.match(regex);
    // to break if we have infinity loop
    if (result == null || loops >= 20) {
      break;
    }
    loops++;
    if (result) {
      const value = result[1].substring(result[1].indexOf('.') + 1);
      const parent = result[1].substring(0, result[1].indexOf('.'));
      if (parent === 'query') {
        if (query[value]) {
          url = url.replace(result[0], query[value]);
        } else {
          url = url.replace(result[0], '');
        }
      } else if (parent == 'user') {
        if (value === 'uuid') {
          url = url.replace(result[0], auth.user.UUID);
        }
      } else {
        url = url.replace(result[0], '');
      }
    }
  }
  return url;
};

const mcpIsNaN = (value: any) => {
  return parseFloat(value) !== value;
};
const convertToSlug = (Text: string, notLowerCase?: boolean): string => {
  let convertedText = Text?.replace(/ /g, '-') // replace spaces with hyphens
    ?.replace(/[^A-Za-z0-9\-]/g, '') //remove special character with hyphens
    ?.replace(/-+/g, '-'); //remove sequential hyphens
  return convertedText;
};

const toCapitalCase = (str: any, title: string) => {
  if (typeof str !== 'string') {
    str = title || '';
  }
  return `${str?.charAt(0)?.toUpperCase()}${str?.substr(1)}`;
};

const bindTabName = ({
  title = '',
  brand = '',
  vertical = '',
  prefix = '',
}) => {
  const { $t } = useNuxtApp();
  title = title?.value ? title.value : title;
  return `${prefix ? $t(prefix) : ''} ${
    title ? toCapitalCase($t(title), title) : ''
  } ${title && brand ? '-' : ''} ${brand ? $t(brand) : ''} ${
    title || brand ? '|' : ''
  } ${vertical ? $t(vertical) : $t('main.title')}`;
};
const hasEntriesLists = (structure: any) => {
  const objectPropertyName =
    (structure?.data?.customProperties &&
      structure.data.customProperties['objectPropName']) ||
    'entries';
  if (structure.substructure?.length) {
    return structure.substructure.some((s: any) => hasEntriesLists(s));
  }
  if (structure.data?.[objectPropertyName]) {
    return true;
  }
  return false;
};

const isNotEmptyStructure = (structure: any) => {
  const objectPropertyName =
    (structure?.data?.customProperties &&
      structure.data.customProperties['objectPropName']) ||
    'entries';
  if (structure.substructure?.length) {
    return structure.substructure.some((sub: any) => isNotEmptyStructure(sub));
  }
  if (structure.data?.[objectPropertyName]?.length) {
    return true;
  }
  return false;
};

const hasEntries = (structures: any) => {
  return structures.some((sub: any) => hasEntriesLists(sub))
    ? structures.some((sub: any) => isNotEmptyStructure(sub))
    : true;
};

const hasErrorCode = (structure: any) => {
  if (structure.substructure?.length) {
    return structure.substructure.some((s: any) => hasErrorCode(s));
  }
  if (structure.data?.errorCode) {
    return true;
  }
  return false;
};

const hasCorruptedEntries = (structures: any) => {
  return structures.some((sub: any) => hasErrorCode(sub)) ? true : false;
};

const dateFormatter = (myDate: string, withTime: boolean = false): string => {
  const date = new Date(myDate);

  if (isNaN(date.getTime())) {
    return '';
  }

  const isoString = date.toISOString();
  const newDate = isoString.slice(0, 10);

  if (withTime) {
    const newTime = isoString.slice(11, 19);
    return `${newDate} ${newTime}`;
  }

  return newDate;
};

const competitionStatus = (startDate: string, endDate: string) => {
  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (startDate || endDate) {
    if (end < now) {
      return 'past';
    } else if (start > now) {
      return 'future';
    } else if (start <= now && end >= now) {
      return 'present';
    }

    return 'unknown';
  }
};

const getTenantName = (req: any): string | null => {
  if (req?.headers['x-tenant-id']) {
    return req?.headers['x-tenant-id'];
  }
  const reqHost = req?.headers?.host;

  const hosts = (application as any).tenants?.root?.default
    ?.hostnameTenantRedirects;

  const tenantObj = hosts.find((element: any) => element?.host == reqHost);
  const countries = tenantObj?.countries;
  if (countries) {
    const countryCode = getCountryCodeFromUrl(req);
    if (countryCode) {
      const country = countries?.find(
        (country: any) => country.code === countryCode,
      );
      if (country) {
        return country?.tenant;
      }
    }
    
    // If no country in URL, use the default country's tenant
    const defaultCountry = countries?.find((country: any) => country.default === true);
    if (defaultCountry) {
      return defaultCountry?.tenant;
    }
  }

  // If no countries or no default country, return the hostname tenant
  const tenantName = hosts.find(
    (element: any) => element?.host == reqHost,
  )?.tenant;
  if (!tenantName) {
    return null;
  }
  return tenantName;
};

const getCountryCodeFromUrl = (req: any): string | null => {
  // Define supported country codes
  const supportedCountryCodes = application?.base?.countries?.supportedCountries;

  if (!req?.url) {
    return null;
  }

  // Remove query parameters and hash fragments
  const cleanUrl = req.url.split('?')[0].split('#')[0];

  // Split URL into path segments and remove empty strings
  const pathSegments = cleanUrl
    .split('/')
    .filter((segment) => segment.length > 0);

  // Check if first path segment is a country code
  if (pathSegments.length > 0) {
    const firstSegment = pathSegments[0].toLowerCase();
    if (supportedCountryCodes.includes(firstSegment)) {
      return firstSegment;
    }
  }
  return null;
};

const getTenantConfigValue = (req: any): any => {
  const tenantName = getTenantName(req);
  if (!tenantName) {
    return null;
  }
  return (application as any)?.tenants[tenantName];
};

const getQueryParamFromUrl = (url: string, queryParamName: string) => {
  const queryStringFromUrl = url.split('?')[1];
  if (!queryStringFromUrl) {
    return null;
  }
  const querySearch = new URLSearchParams(queryStringFromUrl);
  return querySearch.get(queryParamName);
};

const generateUniquePlayer = () => {
  const generatedUsernames = new Set();
  let username;
  do {
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    username = `player${randomNum}`;
  } while (generatedUsernames.has(username));
  generatedUsernames.add(username);
  return username;
};

const getCurrencySymbol = (currency: string): string => {
  const symbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    INR: "₹",
    AUD: "A$",
    CAD: "C$",
    CHF: "CHF",
    KRW: "₩",
    SEK: "kr",
    NOK: "kr",
    DKK: "kr",
    RUB: "₽",
    BRL: "R$",
    ZAR: "R",
  };

  return symbols[currency as keyof typeof symbols] || currency;
};

export {
  cycle,
  price,
  priceCycle,
  calculatefreeTrial,
  calculateDiscount,
  calculateNew,
  goBack,
  array_chunks,
  contentGrading,
  getGenres,
  formatBinarySize,
  detailPrice,
  priceTag,
  closeMenuDuplication,
  replaceUrlParams,
  mcpIsNaN,
  convertToSlug,
  bindTabName,
  toCapitalCase,
  hasEntries,
  currency,
  hasCorruptedEntries,
  dateFormatter,
  competitionStatus,
  getTenantName,
  getCountryCodeFromUrl,
  getTenantConfigValue,
  getQueryParamFromUrl,
  generateUniquePlayer,
  getCurrencySymbol,
  ConsentType,
};
